import { boardCovers } from "./board-projects";
import type { Board, BoardDetail } from "./types";

/**
 * The boards an agent's chat links to: every live board covering the agent's
 * project, as its default or one of several. None for the master, which has no project. The project's main
 * board leads, since it is the one chip a phone shows: one named like the project
 * if there is one, then the oldest first.
 */
export function boardsOfProject(boards: BoardDetail[], projectId: string | null, projectName?: string): Board[] {
  if (!projectId) return [];
  const main = projectName?.trim().toLowerCase();
  return boards
    .filter((detail) => !detail.board.archived && boardCovers(detail, projectId))
    .map((detail) => detail.board)
    .sort(
      (a, b) =>
        Number(b.name.trim().toLowerCase() === main) - Number(a.name.trim().toLowerCase() === main) ||
        a.createdAt.localeCompare(b.createdAt) ||
        a.name.localeCompare(b.name),
    );
}
